import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String, category: String }
    static targets = [ 'column1' ]

    #position = 0;
    #entrys = 1; // Anzahl der Einträge/request

    connect() {
        this.loadMore();
    }
  
    async loadMore() {
        let posts = {};

        const requestUrl = `${this.urlValue}?per_page=${this.#entrys}&offset=${this.#position}&acf_format=standard&categories[include_children]=false&categories[terms][0]=${this.categoryValue}`;
        console.log(requestUrl);
        try {
            const response = await fetch(requestUrl);
            posts = await response.json();
        } catch (error) {
            console.error(error.message);
        }

        posts.forEach(post => {
            let jobCard  = '';
            let tagsHTML = '';
            post.acf.tags.forEach(tag => {
                tagsHTML += `<span class="bg-secondary rounded-xl font-normal font-[16px] px-[13px]">${tag['tag']}</span>`;
            });

            jobCard = `
            <hr class="lg:hidden border-[#a9a8e8]" />
            <a href="${post.acf.url.link}" target="_blank">
            <div class="lg:border lg:border-[#a9a8e8] lg:rounded-3xl lg:px-[34px] lg:px-[34px] py-[25px] my-[25px] lg:bg-white h-full">
                <div class="leading-[1.4] mb-[7px] font-bold text-2xl">
                    ${post.title.rendered} <span class="ml-[10px] font-normal">${post.acf.gender}</span>
                    <div class="flex flex-wrap gap-[10px] justify-start my-[10px] float-none sm:my-0 sm:float-right sm:justify-end font-normal">
                    ${tagsHTML}
                    </div>
                </div>
                <div class="leading-[1.6] font-normal mb-[20px]">${post.excerpt.rendered}</div>
                <div class="leading-[1.8] text-secondary">&gt; ${post.acf.url.linktext}</div>
            </div>
            </a>
            `;
            this.column1Target.innerHTML += jobCard;
        });

        this.#position += this.#entrys;
    }
}